import { RuleTableHandlers, TableConfig } from '../../../../../shared/ui/custom-table/model/table-config.model';
import { isNonDepreciable } from '../../models/investment-asset.model';

export enum InvestmentAssetRowAction {
  Edit = 'edit',
  Delete = 'delete',
  DownloadImage = 'downloadImage',
  DownloadPdf = 'downloadPdf',
  Amortisation = 'amortisation',
  Pay = 'pay',
  Contabilizar = 'contabilizar',
  AddAmortisationAccounting = 'addAmortisationAccounting',
  DeleteAmortisationAccounting = 'deleteAmortisationAccounting',
}

export function createInvestmentAssetTableConfig(
  handlers: RuleTableHandlers = {},
  options: { filterView?: string } = {}
): TableConfig {
  const {
    onAction = () => { },
    actionMap = {},
    onRowClick = () => { },
    onRowDblClick = () => { },
    onRowExpand = () => { },
    selectable = false,
    summaryTemplate,
    rowConfig = {},
    headerActions,
    gridActions,
    columns,
  } = handlers;

  const handleAction = (row: any, action: InvestmentAssetRowAction) => {
    if (actionMap[action]) {
      actionMap[action](row);
    } else {
      onAction(row, action);
    }
  };

  return {
    columns: columns,
    actions: [
      { label: 'Editar', icon: 'edit', callback: (row) => handleAction(row, InvestmentAssetRowAction.Edit) },
      { label: 'Pagos', icon: 'payment', callback: (row) => handleAction(row, InvestmentAssetRowAction.Pay) },
      { label: 'Cuadro de amortización', icon: 'insert_chart', callback: (row) => handleAction(row, InvestmentAssetRowAction.Amortisation) },
      {
        label: 'Contabilizar amortización del ejercicio', icon: 'show_chart',
        visible: (row) => !!row && row.amortisationYearExists === false && !isNonDepreciable(row),
        callback: (row) => handleAction(row, InvestmentAssetRowAction.AddAmortisationAccounting),
      },
      {
        label: 'Eliminar contabilización de la amortización', icon: 'delete',
        visible: (row) => !!row && row.amortisationYearExists === true,
        callback: (row) => handleAction(row, InvestmentAssetRowAction.DeleteAmortisationAccounting),
      },
      { label: 'Contabilizar (asiento libre)', icon: 'show_chart', callback: (row) => handleAction(row, InvestmentAssetRowAction.Contabilizar) },
      {
        label: 'Descargar documento (imagen)', icon: 'image',
        visible: (row) => !!row && row.image === true,
        callback: (row) => handleAction(row, InvestmentAssetRowAction.DownloadImage),
      },
      {
        label: 'Descargar documento (PDF)', icon: 'attach_file',
        visible: (row) => !!row && row.pdf === true,
        callback: (row) => handleAction(row, InvestmentAssetRowAction.DownloadPdf),
      },
      { label: 'Eliminar', icon: 'delete', callback: (row) => handleAction(row, InvestmentAssetRowAction.Delete) },
    ],
    headerActions: headerActions,
    gridActions: gridActions,
    filterView: options.filterView || '',
    rowConfig: {
      ...rowConfig,
      clickable: true,
      onClick: onRowClick,
      onDoubleClick: onRowDblClick,
      onExpand: onRowExpand,
    },
    selectable: selectable,
    pagination: true,
    summaryTemplate: summaryTemplate,
  };
}
